import { Moment } from 'moment';

// SoldHours

export enum DateFilterByTypes {
  entry = 'Entry',
  authorization = 'Authorization',
  closing = 'Closing',
  leave = 'Leave',
}

export enum HoursSoldReportType {
  employee = 'Employee',
  area = 'Area',
}

export enum WorkOrderTypes {
  budget = 'budget',
  warranty = 'warranty',
  return = 'return',
  courtesy = 'courtesy',
  totalLoss = 'totalLoss',
  revision = 'revision',
}

export interface ReportWorkOrderSoldHoursForm {
  initialDate: Moment;
  finalDate: Moment;
  companiesIds: number[];
  dateFilterBy: DateFilterByTypes;
  situation: string;
  typeReport: HoursSoldReportType;
  workDays: number;
  workHours: number;
  hideAverageByArea: boolean;
  showModelAndVersion: boolean;
  showWorkOrder: boolean;
  showWarranty: boolean;
  showReturn: boolean;
  showCourtesy: boolean;
  showTotalLoss: boolean;
  showRevision: boolean;
  employeeIds: string;
  areaIds: string;
  type: WorkOrderTypes;
}

export interface ReportWorkOrderSoldHoursRequest {
  companiesIds: string;
  startDate: string;
  endDate: string;
  dateFilterBy: DateFilterByTypes;
  open: boolean;
  authorized: boolean;
  closed: boolean;
  cancelled: boolean;
  typeReport: HoursSoldReportType;
  workDays: number;
  workHours: number;
  hideAverageByArea: boolean;
  showModelAndVersion: boolean;
  showWorkOrder: boolean;
  showWarranty: boolean;
  showReturn: boolean;
  showCourtesy: boolean;
  showTotalLoss: boolean;
  showRevision: boolean;
  employeeIds: string;
  areaIds: string;
}

export interface ReportWorkOrderQuotationMapRequest {
  workOrderId: number;
  complementNumber: number;
  onlyInternal: boolean;
  outOfStock?: boolean;
}
